import { StyledGptBigbox } from '@/components-page/vip/advertisement/styled'
import { VIP_GPT_ID } from '@/components-page/vip/advertisement/vipAdSlots'

type GptBigBoxProps = {
  isMobile?: boolean
}

export const GptBigbox = ({ isMobile }: GptBigBoxProps) => {
  return (
    <StyledGptBigbox
      id={VIP_GPT_ID.GPT_BIGBOX}
      data-testid={VIP_GPT_ID.GPT_BIGBOX}
      $isMobile={isMobile}
    />
  )
}
